<template>
  <div class="container" :style="cssProps">
    <alert ref="alert"></alert>
    <h1>Payment Method</h1>
    <h2>Select a valid payment method to continue.</h2>
    <h3 v-if="info.savedCardDetails.length > 0">Current</h3>
    <div class="container-current">
      <div class="cardStorage d-flex flex-row">
       
      <div class="current-card d-flex flex-row active" v-if="info.savedCardDetails[info.choosedCardIndex]">
        <i :class="'fab fa-cc-' + getCardInfo(info.savedCardDetails[info.choosedCardIndex].cardnumber).type"></i>
        <div class="global-container d-flex flex-column align-items-start justify-content-center">
          <span>{{getCardInfo(info.savedCardDetails[info.choosedCardIndex].cardnumber).niceType}}</span>
          <div class="container-number d-flex flex-row justify-content-between">
            <div class="d-flex flex-row align-items-center">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <span class="lastnum">{{info.savedCardDetails[info.choosedCardIndex].cardnumber.slice(info.savedCardDetails[info.choosedCardIndex].cardnumber.length - 5, info.savedCardDetails[info.choosedCardIndex].cardnumber.length)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="select-card d-flex flex-row align-items-center justify-content-between" @click="openOtherCard">
        <span>Select Other Credit Card</span>
        <i class="fal fa-angle-right"></i>
      </div>
      </div>

      <h3>New Method</h3>
      <div class="container-method d-flex flex-row">
        <button
          type="button"
          class="d-flex flex-column justify-content-between align-items-start"
          @click="chooseMethod('creditcard')"
          :class="paymentMethod === 'creditcard'? 'active': ''"
        >
          <i class="fal fa-credit-card-blank"></i>
          <span>Credit Card</span>
        </button>
        <button type="button" class="d-flex flex-column justify-content-between align-items-start" @click="chooseMethod('cash')" :class="paymentMethod === 'cash'? 'active': ''">
          <i class="far fa-money-bill-wave-alt"></i>
          <span>Cash</span>
        </button>
        <button type="button" class="d-flex flex-column justify-content-between align-items-start" >
       <i class="fal fa-gift-card"></i>
          <span>Gift</span>
        </button>
      </div>
    </div>
    <div class="container-button d-flex flex-row align-items-center">
      <button type="button" class="btn-cont" @click="Delivery">
        <span>Continue</span>
      </button>
      <div class="modify_link d-flex">
        <a href="#" @click.prevent="clear">Clear selected</a>
      </div>
    </div>
    <cardmodal ref="cardmodal" @submit="savecardInfo"></cardmodal>
    <selectcard ref="selectcard" @submit="chooseCard"></selectcard>
  </div>
</template>
<script>
import { mapState } from "vuex";
import cardModal from "./modals/cardModal.vue";
import alert from './custom/alert.vue';
import selectcard from "./modals/selectcard.vue";
import creditCardType from 'credit-card-type';
export default {
  name: "payment",
  components: {
    cardmodal: cardModal,
    selectcard:selectcard,
    alert
  },
  data() {
    return {
      paymentMethod: null,
      choosedCard: null,
    }
  },
  computed: {
    ...mapState(["info"]),
    cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    }
  },
  methods: {
    Delivery() {
      if(this.info.paymentMethod === 'cash'){
          this.$router.push({
          name: "review"
        });
      }
      else if(this.info.paymentMethod === 'creditcard' && this.info.savedCardDetails[this.info.choosedCardIndex]){
        this.$router.push({
          name: "review"
        });
      }
      else{
        this.$refs.alert.message = "Choose payment method or credit card";
        this.$refs.alert.show();
      }
    },
    chooseMethod(method){
      this.paymentMethod = method;
      this.$store.commit('paymethod.set', {method});
      if(this.paymentMethod === "creditcard"){
        this.$refs.cardmodal.show();
      }
      else{
        this.choosedCard = null;
      }
    },
    openOtherCard(){
      this.$refs.selectcard.show()
    },
    savecardInfo(cardInfo){
      this.$store.commit('card.add', {card: cardInfo});
      this.choosedCard = this.info.savedCardDetails.length - 1;
      this.$store.commit('card.set', { index: this.info.savedCardDetails.length - 1});
      
    },
    chooseCard(index){
      this.choosedCard = index;
      this.$store.commit('card.set', {index});
      if(!this.paymentMethod){
        this.paymentMethod = 'creditcard';
        this.$store.commit('paymethod.set', {method: 'creditcard'});
        // this.chooseMethod('creditcard');
      }

    },
    getCardInfo(cardnumber){
      let type = creditCardType(cardnumber)
      // console.log(type.niceType)
      return type[0]
    },
    clear(){
      this.chooseMethod(null);
      this.$store.commit('card.set', { index: null});
    }
  },
  created(){
    let thisRef = this;
    this.paymentMethod = this.info.paymentMethod;

  }
};
</script>
<style scoped>
.select-card i 
{
  
	opacity: 0.8;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 24px;
	font-weight: 300;
	line-height: 24px;
	text-align: center;

}
.select-card span{
  
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;

}
.select-card
{
  margin-left: 8px;
  padding: 24px;
	height: 76px;
	width: 333px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 8px;
	background-color: #FFFFFF;
}

button {
  border: none;
  padding: 0;
  background: none;
  outline: none;
}
.container-method {
  padding-top: 24px;
}
.container-method button {
  height: 112px;
  width: 158px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  background-color: #ffffff;
  margin-left: 8px;
  padding: 24px;
}
.container-method button:first-child {
  height: 112px;
  width: 158px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  background-color: #ffffff;
  margin-left: 0px;
}
.container-method button i {
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.container-method button span {
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: bold;
  line-height: 20px;
  white-space: nowrap;
}

.global-container {
  padding-left: 16px;
  width: 100%;
}
.global-container span:first-child {
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
}

.container-number {
  width: 50%;
}
.lastnum {
  opacity: 0.6;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-left: 5px;
}
.dot {
  -moz-border-radius: 50px/50px;
  -webkit-border-radius: 50px 50px;
  border-radius: 50px/50px;
  border: 1px solid rgba(0, 0, 0, 0.6);
  background-color: #ffffff;
  width: 5px;
  height: 5px;
  margin-left: 1px;
  opacity: 0.6;
}

.container-current {
  padding-top: 24px;
}

.current-card {
  height: 76px;
  width: 333px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
  padding: 14px;
  margin-left: 8px;
}
.current-card:first-child{
  margin-left: 0px;
}
.current-card i {
  height: 48px;
  width: 54px;
  opacity: 0.6;
  color: #000000;
  font-family: "Font Awesome 5 Brands";
  font-size: 40px;
  line-height: 48px;
  text-rendering: geometricPrecision;
}
.container {
  padding: 47px;
}
.container h1 {
  text-transform: uppercase;
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 800;
  line-height: 35px;
}
.container h2 {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  line-height: 20px;
}
.container h3 {
  padding-top: 48px;
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
}
.container-button {
  padding-top: 48px;
  width: 100%;
}
.btn-cont {
  height: 48px;
  width: 201px;
  border-radius: 24px;
  background-color: var(--main-color);
}
.btn-cont span {
  color: #ffffff;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
}
.modify_link {
  /* width: 10%; */
  padding-left: 10%;
}
.modify_link a {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: right;
  text-decoration: underline;
  white-space: nowrap;
}
.active {
  background-color: var(--main-color) !important;
}
.active i {
  color: #ffffff !important;
}
.active span {
  color: #ffffff !important;
}
@media screen and (max-width: 600px)

{
  .container-method
  {
    flex-direction: column !important;
  }
  .container-method button
  {
    margin-top: 8px !important;
    width: 100% !important;
    margin-bottom: 0 !important;
    margin-left: 0;
  }
   .current-card
  {
    margin-left:0;
    margin-top: 8px;
    width: 100%;
  }
  .container-number
  {
    width: 65%;
  }
  .container-button
    {
        flex-direction: column !important;
        margin-bottom: 80px;
    }
    .container-button .btn-cont
    {
        width: 100%;
    }
    .modify_link 
    {
        padding-top: 15px !important;
        padding-left: 0!important;
    }
    .cardStorage  {
        flex-direction: column !important;

      }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/payment.vue